import { type RouteObject } from 'react-router-dom';
import { PatientTimelineTestPage } from '@features/patient-artifacts';
import { SubscriptionMultiStepFlow } from '@features/subscriptions';

import { Auth0ProviderWithNavigate } from '../auth0-provider';
import { RootErrorBoundary } from '../components/errors/RootErrorBoundary';

import { AuthenticatedLayout } from './layouts/AuthenticatedLayout';

export const devRoutes: RouteObject[] = [
  {
    path: '/',
    element: <AuthenticatedLayout />,
    errorElement: (
      <Auth0ProviderWithNavigate>
        <RootErrorBoundary />
      </Auth0ProviderWithNavigate>
    ),
    children: [
      {
        path: '/test-payment',
        element: <SubscriptionMultiStepFlow />,
      },
      {
        path: '/timeline',
        element: <PatientTimelineTestPage />,
      },
    ],
  },
];
